import {AuthProvider} from '@/context/Auth/AuthProvider'
import useInternationalization from '@/internationalization/useInternationalization'
import {persistor, store} from '@/store'
import {DEFAULT_INTL} from '@/utils/constants/globalConstants'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ThemeProvider} from 'pepsico-ds'
import {IntlProvider} from 'react-intl'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import './assets/scss/App.scss'

import {useSetCSSVariables} from '@/utils/constants/colors'
import {AppRouter} from './routes/AppRouter'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
})

function App({shellActive = false, darkTheme = false, path = ''}) {
  const [language, message] = useInternationalization(DEFAULT_INTL)
  useSetCSSVariables()
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <IntlProvider locale={language} messages={message}>
            <AuthProvider>
              <ThemeProvider defaultStyle="Dark Peacock">
                <AppRouter shellActive={shellActive} darkTheme={darkTheme} path={path} />
              </ThemeProvider>
            </AuthProvider>
          </IntlProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
